enum QueryKeys {
  USERS = "USERS",
  USER = "USER",
  MAIN_USER = "MAIN_USER",
  APP_PARAMS = "APP_PARAMS",
  LANGUAGES = "LANGUAGES",
  SUB_USERS = "SUB_USERS",
  SUB_USER = "SUB_USER",
  SUBSCRIPTIONS = "SUBSCRIPTIONS",
  SUBSCRIPTION = "SUBSCRIPTION",
  PROMPTS = "PROMPTS",
  PROMPT = "PROMPT",
  ORGANIZATIONS = "ORGANIZATIONS",
  ORGANIZATION = "ORGANIZATION",
  B2B_ADMINS = "B2B_ADMINS",
  B2B_ADMIN = "B2B_ADMIN",
  B2B_SUBSCRIPTIONS = "B2B_SUBSCRIPTIONS",
  B2B_SUBSCRIPTION = "B2B_SUBSCRIPTION",
  USERS_EXPORTS = "USERS_EXPORTS",
  SUBSCRIPTION_DISCOUNTS = "SUBSCRIPTION_DISCOUNTS",
  TOGGLE_SUBSCRIPTION_DISCOUNT = "TOGGLE_SUBSCRIPTION_DISCOUNT",
  DEVICE_INFO = "DEVICE_INFO",
  SUB_USER_DEVICE_INFO = "SUB_USER_DEVICE_INFO",
  AUTOMATION_LANGUAGES = "AUTOMATION_LANGUAGES",
  AUTOMATION_JOBS = "AUTOMATION_JOBS",
  AUTOMATION_PROMPTS = "AUTOMATION_PROMPTS",
  USER_CONSENTS = "USER_CONSENTS",
  CONSENT_AUDIT = "CONSENT_AUDIT",
  SG_TEMPLATES = "SG_TEMPLATES",
  NOTIFICATION_MANAGEMENTS = "NOTIFICATION_MANAGEMENTS",
  NOTIFICATION_TYPES = "NOTIFICATION_TYPES",
  NOTIFICATION_KEYS_VALUES = "NOTIFICATION_KEYS_VALUES",
  USERS_WITH_FCM_TOKEN = "USERS_WITH_FCM_TOKEN",
}

interface IErrorResponse {
  error:
    | string
    | {
        response: {
          data: {
            message: string;
          };
        };
      };
  message: string;
  statusCode: number;
}

const defaultQueryOptions = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: true,
};

export { QueryKeys, defaultQueryOptions };
export type { IErrorResponse };
